import { render } from "./RatingSetBar.vue?vue&type=template&id=4658f8ac&scoped=true"
import script from "./RatingSetBar.vue?vue&type=script&lang=js"
export * from "./RatingSetBar.vue?vue&type=script&lang=js"

import "./RatingSetBar.vue?vue&type=style&index=0&id=4658f8ac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4658f8ac"]])

export default __exports__